module.exports = __webpack_public_path__ + "static/img/1808_7.8c3af93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1808_7.jpg
// module id = CrXG
// module chunks = 1